import React, { useState, useRef, useEffect } from 'react'
import ResponseMsg from '../general/ResponseMsg';
import Camera from '../assets/camera-img.png';
import '../css/Admin/AddProduct.css';
import Loading from '../general/Loading';

const AddProduct = () => {
    const [response, setResponse] = useState(null);
    const [uniqueCategory, setUniqueCategory] = useState([]);
    const [showUpload, setShowUpload] = useState(false);
    const [excelFile, setExcelFile] = useState(null);
    const [newCategory, setNewCategory] = useState('');
    const [loading, setLoading] = useState(true);
    const [newLoading, setNewLoading] = useState(false);
    const [products, setProducts] = useState([]);
    const [formData, setFormData] = useState({
        productName: '',
        productUnit: '',
        // stock: '',
        barcode: '',
        hsnCode: '',
        category: '',
        mfgDate: '',
        expDate: '',
        image: null,
        purchasePrice: '',
        originalPrice: '',
        sellPrice: '',
        sellPriceTax: 'with tax',
        tax: 'none',
        discountType: '',
        discountGiven: '',
        description: '',
        prescription: ''
    });
    const [imagePreview, setImagePreview] = useState(null);


    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await fetch(`https://api.kcmstore.in/dist/get-medicine`);
                if (response.ok) {
                    const data = await response.json();
                    const sortedProducts = data.sort((a, b) => b.medicine_id - a.medicine_id);
                    setProducts(sortedProducts);
                    setLoading(false);
                    const uniqueCategories = [...new Set(sortedProducts.map(product => product.category))];
                    setUniqueCategory(uniqueCategories);
                } else {
                    console.error('Failed to fetch products');
                    setLoading(false);
                }
            } catch (error) {
                console.error('Error fetching products:', error);
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);


    const fileInputRef = useRef(null);
    const handleImageClick = () => {
        fileInputRef.current.click(); // Trigger file input click
    };

    const handleChange = (e) => {
        const { id, value, type, files } = e.target;
        if (type === 'file') {
            setFormData({
                ...formData,
                [id]: files[0]
            });
            // Update image preview
            const file = files[0];
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            if (file) {
                reader.readAsDataURL(file);
            }
        } else {
            setFormData({
                ...formData,
                [id]: value
            });
        }
    };

    const handleNewCategoryChange = (e) => {
        setNewCategory(e.target.value);
    };

    const handleAddNewCategory = () => {
        if (newCategory.trim()) {
            setFormData({ ...formData, category: newCategory });
            setUniqueCategory((prevCategories) => [...prevCategories, newCategory]);
            setNewCategory('');
            setResponse(`New category added: ${newCategory}`);
            setTimeout(() => {
                setResponse('');
            }, 2000);
        }
    };

    const handleCancel = () => {
        // Clear the selected category and close the dialog
        setFormData({
            ...formData,
            category: '',
        });
        setNewCategory(''); // Reset the new category input
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setNewLoading(true);

        const formDataToSubmit = new FormData();
        Object.keys(formData).forEach((key) => {
            formDataToSubmit.append(key, formData[key]);
        });

        try {
            const response = await fetch('https://api.kcmstore.in/dist/add-product', {
                method: 'POST',
                body: formDataToSubmit
            });
            setNewLoading(false);

            if (response.ok) {
                setResponse('Product added successfully!');
                setTimeout(() => {
                    setResponse('');
                }, 2000);
                setFormData({
                    productName: '',
                    productUnit: '',
                    // stock: '',
                    barcode: '',
                    hsnCode: '',
                    category: '',
                    mfgDate: '',
                    expDate: '',
                    image: null,
                    purchasePrice: '',
                    originalPrice: '',
                    sellPrice: '',
                    sellPriceTax: 'with tax',
                    tax: 'none',
                    discountType: '',
                    discountGiven: '',
                    description: '',
                    prescription: ''
                });
                setImagePreview(null);
            } else {
                setNewLoading(false);
                setResponse('Failed to add product.');
                setTimeout(() => {
                    setResponse('');
                }, 2000);
            }
        } catch (error) {
            setNewLoading(false);
            console.error('Error:', error);
        }
    };


const handleExcelUpload = async (e) => {
  e.preventDefault();
  if (!excelFile) return;

  const uploadFormData = new FormData();
  uploadFormData.append('file', excelFile);
              setNewLoading(true);

  try {
    const response = await fetch('https://api.kcmstore.in/dist/upload-livestock-data', {
      method: 'POST',
      body: uploadFormData
    });

    const data = await response.json();

    if (response.ok) {
        setShowUpload(false);
            setNewLoading(false);
      setResponse('Bulk upload successful!');
    } else {
        setShowUpload(false);
            setNewLoading(false);
      setResponse(data.message);
    }
  } catch (error) {
            setNewLoading(false);
    console.error('Upload error:', error);
  }

  setTimeout(() => {
    setResponse('');
  }, 2000);
};


    return (
        <>
            <section className='px-3 py-3'>
                <div className='profile-area-inner px-lg-5 py-lg-5 px-3 py-3 animate__animated animate__fadeInUp'>

                    <div className='d-md-flex justify-content-between'>
                    <p className='profile-heading'>Add Product</p>
                    {/* <button className='add-btn px-3 py-1 para-text' onClick={() => setShowUpload(true)}>Bulk Upload</button> */}
                    <button className='add-btn px-3 py-1 para-text' onClick={() => setShowUpload(true)}>Upload Live Stock</button>
                    </div>
                    <hr className='profile-hr' />

                    <form className="row g-3 bg-white rounded-4" onSubmit={handleSubmit}>
                        {/* Product Name */}

                        <input
                            type="file"
                            className="profile-input bg-white mt-2"
                            id="image"
                            ref={fileInputRef}
                            onChange={handleChange}
                            style={{ display: 'none' }}
                        />
                        <img
                            src={imagePreview || Camera}
                            className='camera-img w-auto'
                            alt="Logo"
                            onClick={handleImageClick}
                        />

                        <p className='profile-subheading mt-5'>Product Details</p>

                        <div className="col-md-4">
                            <label htmlFor="productName" className="profile-label text-muted">Product Name</label>
                            <input
                                type="text"
                                className="profile-input"
                                id="productName"
                                value={formData.productName}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {/* Product Unit */}
                        <div className="col-md-4">
                            <label htmlFor="productUnit" className="profile-label text-muted">Product Unit</label>
                            <input
                                type="text"
                                className="profile-input"
                                id="productUnit"
                                placeholder='Tablets, Capsules, Gel, Supplements...'
                                value={formData.productUnit}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="col-md-4 add-label-area">
                            <label htmlFor="category" className="profile-label text-muted">Category</label>
                            <select
                                id="category"
                                className="profile-input"
                                value={formData.category}
                                onChange={handleChange}
                            >
                                <option value="" disabled>Select Category</option>
                                <option value="addNewCategory" className='bg-primary cursor-pointer text-light fw-semibold'>Add New Category</option>
                                {loading ? (
                                    <option>Loading...</option>
                                ) : (
                                    // Map over the unique categories
                                    uniqueCategory.map((category, index) => (
                                        <option key={index} value={category}>
                                            {category}
                                        </option>
                                    ))
                                )}
                            </select>

                            {formData.category === 'addNewCategory' && (
                                <div className="category-dialog animate__animated animate__zoomIn px-2">
                                    <div className='category-dialog-inner col-lg-5 mx-auto px-lg-5 py-lg-5 px-3 py-3'>
                                        <div className='my-4 add-label-area'>
                                            <label htmlFor="newCategory" className="profile-label text-muted">New Category</label>
                                            <input
                                                type="text"
                                                id='newCategory'
                                                className="profile-input"
                                                placeholder="Enter New Category"
                                                value={newCategory}
                                                onChange={handleNewCategoryChange}
                                            />
                                        </div>
                                        <button className='login-btn px-3 py-1 bg-danger' onClick={handleCancel}>Cancel</button>&nbsp;&nbsp;
                                        <button type="button" className="login-btn px-3 py-1" onClick={handleAddNewCategory}>Add</button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Barcode */}
                        <div className="col-md-3">
                            <label htmlFor="barcode" className="profile-label text-muted">Barcode</label>
                            <input
                                type="text"
                                className="profile-input"
                                id="barcode"
                                value={formData.barcode}
                                onChange={handleChange}
                            />
                        </div>

                        {/* HSN Code */}
                        <div className="col-md-3">
                            <label htmlFor="hsnCode" className="profile-label text-muted">HSN Code</label>
                            <input
                                type="text"
                                className="profile-input"
                                id="hsnCode"
                                value={formData.hsnCode}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Manufacturing Date */}
                        <div className="col-md-3">
                            <label htmlFor="mfgDate" className="profile-label text-muted">Mfg Date</label>
                            <input
                                type="date"
                                className="profile-input"
                                id="mfgDate"
                                value={formData.mfgDate}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Expiry Date */}
                        <div className="col-md-3">
                            <label htmlFor="expDate" className="profile-label text-muted">Exp Date</label>
                            <input
                                type="date"
                                className="profile-input"
                                id="expDate"
                                value={formData.expDate}
                                onChange={handleChange}
                            />
                        </div>

                        <p className='profile-subheading mt-5'>Price Details</p>

                        {/* Purchase Price */}
                        <div className="col-md-4">
                            <label htmlFor="purchasePrice" className="profile-label text-muted">Purchase Price</label>
                            <input
                                type="number"
                                className="profile-input"
                                id="purchasePrice"
                                value={formData.purchasePrice}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {/* Original Price */}
                        <div className="col-md-4">
                            <label htmlFor="originalPrice" className="profile-label text-muted">Original MRP</label>
                            <input
                                type="number"
                                className="profile-input"
                                id="originalPrice"
                                value={formData.originalPrice}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {/* Sell Price */}
                        <div className="col-md-4">
                            <label htmlFor="sellPrice" className="profile-label text-muted">Sell Price</label>
                            <input
                                type="number"
                                className="profile-input"
                                id="sellPrice"
                                value={formData.sellPrice}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {/* Sell Price Tax */}
                        <div className="col-md-3">
                            <label className="profile-label text-muted" htmlFor="sellPriceTax">Sell Price Tax</label>
                            <select
                                className="profile-input"
                                id="sellPriceTax"
                                value={formData.sellPriceTax}
                                onChange={handleChange}
                            >
                                <option value="with tax" selected>With Tax</option>
                                <option value="without tax">Without Tax</option>
                            </select>
                        </div>

                        {/* Tax Applicable */}
                        <div className="col-md-3">
                            <label className="profile-label text-muted" htmlFor="tax">Tax Applicable</label>
                            <select
                                className="profile-input"
                                id="tax"
                                value={formData.tax}
                                onChange={handleChange}
                                selected
                            >
                                <option value="none">None</option>
                                <option value="GST 0">GST 0%</option>
                                {/* <option value="IGST 0">IGST 0%</option> */}
                                <option value="GST 0.25">GST 0.25%</option>
                                {/* <option value="IGST 0.25">IGST 0.25%</option> */}
                                <option value="GST 3">GST 3%</option>
                                {/* <option value="IGST 3">IGST 3%</option> */}
                                <option value="GST 5">GST 5%</option>
                                {/* <option value="IGST 5">IGST 5%</option> */}
                                <option value="GST 12">GST 12%</option>
                                {/* <option value="IGST 12">IGST 12%</option> */}
                                <option value="GST 18">GST 18%</option>
                                {/* <option value="IGST 18">IGST 18%</option> */}
                                <option value="GST 28">GST 28%</option>
                                {/* <option value="IGST 28">IGST 28%</option> */}
                            </select>
                        </div>

                        {/* Discount Type */}
                        <div className="col-md-3">
                            <label className="profile-label text-muted" htmlFor="discountType">Sell Price Discount</label>
                            <select
                                className="profile-input"
                                id="discountType"
                                value={formData.discountType}
                                onChange={handleChange}
                                selected
                            >
                                <option value="">Choose...</option>
                                <option value="percent">Percent %</option>
                                <option value="amount">Amount ₹</option>
                            </select>
                        </div>

                        {/* Discount Given */}
                        <div className="col-md-3">
                            <label className="profile-label text-muted" htmlFor="discountGiven">Discount Given</label>
                            <input
                                type="number"
                                className="profile-input"
                                id="discountGiven"
                                value={formData.discountGiven}
                                onChange={handleChange}
                            />
                        </div>


                        <p className='profile-subheading mt-5'>Related Info</p>

                        {/* Description */}
                        <div className="col-md-4">
                            <label htmlFor="description" className="profile-label text-muted">Description</label>
                            <textarea
                                className="profile-input"
                                style={{ height: '9em' }}
                                id="description"
                                value={formData.description}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Prescription */}
                        <div className="col-md-4">
                            <label htmlFor="prescription" className="profile-label text-muted">Prescription</label>
                            <textarea
                                className="profile-input"
                                style={{ height: '9em' }}
                                id="prescription"
                                value={formData.prescription}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Submit Button */}
                        <div className="col-12 text-end">
                            <button type="submit" className="login-btn">Submit Details</button>
                        </div>
                    </form>

                </div>
            </section>

            {newLoading && <Loading setLoading={setNewLoading} />}
            {response && <ResponseMsg message={response} />}

            {showUpload && (
                <>
                {showUpload && (
                            <section className='detail-dialog'>
          <div className='detail-dialog-inner col-lg-4 mx-auto px-lg-4 py-4 px-2 text-center'>

  <form className="my-4" onSubmit={handleExcelUpload}>
    <div className="col-12 mb-3">
      <label htmlFor="excelFile" className="profile-label text-muted mb-2">Upload Excel File</label>
      <input
        type="file"
        className="profile-input"
        id="excelFile"
        accept=".xlsx, .xls"
        onChange={(e) => setExcelFile(e.target.files[0])}
        required
      />
    </div>
                <button className='login-btn px-3 py-1 mt-2 bg-danger' onClick={() => setShowUpload(false)}>Close</button>&nbsp;&nbsp;
    <button type="submit" className="login-btn px-3 py-1 mt-2">Submit</button>
  </form>
  </div>
  </section>
)}
                </>
            )}

        </>
    )
}

export default AddProduct
